module.exports = __webpack_public_path__ + "img/Telelader.e6e08212.svg";